module.exports = __webpack_public_path__ + "static/media/coldDrinks.e1034c21.webp";